/**
 * sk-room used for displaying rooms in the rooms listing and for displaying the selected room on the extras screen.
 */
bookingApp.directive('skRoom',function(){
    return {
        template:'<div class="room">' +
            '<div class="room-thumbnail">' +
            '</div>' +
            '<div class="room-blurb">' +
                '<h2><strong class="roomMarketingName">{{roomName}}</strong></h2>' +
                '<div class="rate">' +
                    '<div class="name">' +
                        '<h2>{{rateName}}</h2>' +
                    '</div>' +
                '</div>' +
                '<div class="max-pax">' +
                    '<span class="badge">' +
                        '<span class="glyphicon glyphicon-user"></span> {{maxPax}}' +
                    '</span>' +
                '</div>' +
                '<div class="pax-config" ng-show="showPaxConfig === true">' +
                    '<div class="adults" ng-show="paxAdults > 0">{{paxAdults|paxLabel:\'adult\'}} x {{paxAdults}}</div>' +
                    '<div class="children" ng-show="paxChildren > 0">{{paxChildren|paxLabel:\'child\'}} x {{paxChildren}}</div>' +
                    '<div class="infants" ng-show="paxInfants > 0">{{paxInfants|paxLabel:\'infant\'}} x {{paxInfants}}</div>' +
                '</div>' +
                '<div class="rooms-remaining" ng-show="showRoomsRemaining">' +
                    '{{roomsRemaining}} {{\'Rooms\' | marketingGroup : roomsRemaining > 1 ? \'plural\' : \'single\' : marketingGroup}} {{\'Remaining\' | remainingLabel : remainingLabelVal}}' +
                '</div>' +
            '</div>' +
            '<div class="price">' +
                '<div class="price-from-text">From:</div>' +
                '<h3>{{rackRate}}</h3>' +
                '<h3>{{price}}</h3>' +
            '</div>' +
            '<div class="deal">' +
                '<div class="deal-badge hot-deal" ng-show="isHotDeal">' +
					'<span class="glyphicon glyphicon-fire"></span> Hot Deal!' +
				'</div>' +
				'<div class="deal-badge limited-space" ng-show="isLimited">' +
					'<span class="glyphicon glyphicon-time"></span> Limited' +
				'</div>' +
				'<div class="deal-badge on-request" ng-show="isOnRequest">' +
					'<span class="glyphicon glyphicon-warning-sign"></span> On Request' +
				'</div>' +
            '</div>' +
        '</div>',
        scope: {
            thumbnails: '=?',
            initialThumbnailIndex: '=?',
            roomName: '=',
            rateName: '=',
            roomsRemaining: '=?',
            maxPax: '=?',
            rackRate: '=?',
            price: '=?',
            paxAdults: '=?',
            paxChildren: '=?',
            paxInfants: '=?',
            showPaxConfig: '=?',
            // settings for ng-show
            showRoomsRemaining: '=?',
            // badges
            isHotDeal: '=?',
            isLimited: '=?',
            isOnRequest: '=?',
            marketingGroup: '=?',
	        remainingLabelVal: '=?',
            uniquenessReached: '=?'
        },
        link: function(scope, element, attrs){
            if(scope.thumbnails && scope.thumbnails.length > scope.initialThumbnailIndex) {
                element.find('.room-thumbnail').css('background-image', 'url(' + scope.thumbnails[scope.initialThumbnailIndex] + ')');
            }
            // hide "From" text if now rack rate is set
            if(!scope.rackRate){
                element.find('.price-from-text').text('Price');
            }
            // hide max pax if none passed in
            if(!scope.maxPax){
                element.find('.max-pax').hide();
            }
        }
    }
});
